import {combineReducers} from "redux";

import organize from "./organize";
import dialog from "./new-publication-dialog.reducer";

export default combineReducers({
    dialog,
    organize,
});